import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-88211a4e"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_3 = {
  key: 5,
  class: "action_btn_box"
}
const _hoisted_4 = /*#__PURE__*/_createTextVNode("编辑")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input_search = _resolveComponent("a-input-search")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_ImageView = _resolveComponent("ImageView")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_OwnerSet = _resolveComponent("OwnerSet")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_card, {
      title: "货主管理",
      style: {"margin-bottom":"16px"},
      bordered: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, { layout: "inline" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, { label: "搜索" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input_search, {
                  value: _ctx.searches.name,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searches.name) = $event)),
                  "enter-button": "",
                  onSearch: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onSearch('nickname', $event, $event))),
                  placeholder: "搜索"
                }, null, 8, ["value"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_a_table, {
      dataSource: _ctx.list,
      columns: _ctx.columns,
      loading: _ctx.loading,
      bordered: "",
      pagination: _ctx.pagination,
      onChange: _ctx.handleTableChange
    }, {
      bodyCell: _withCtx(({ column, text, record }) => [
        (column.key === 'avatar')
          ? (_openBlock(), _createBlock(_component_ImageView, {
              key: 0,
              "image-url": text
            }, null, 8, ["image-url"]))
          : _createCommentVNode("", true),
        (column.key === 'approve')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("a", {
                style: _normalizeStyle({color: record.vali_real_name ? '#87d068' : '#ff7875'})
              }, "实名认证：" + _toDisplayString(record.vali_real_name ? '已认证' : '未认证'), 5),
              _hoisted_1,
              _createElementVNode("a", {
                style: _normalizeStyle({color: record.vali_driver ? '#87d068' : '#ff7875'})
              }, "驾驶证认证：" + _toDisplayString(record.vali_driver ? '已认证' : '未认证'), 5),
              _hoisted_2,
              _createElementVNode("a", {
                style: _normalizeStyle({color: record.vali_vehicle ? '#87d068' : '#ff7875'})
              }, "行驶证/物流运输证认证：" + _toDisplayString(record.vali_vehicle ? '已认证' : '未认证'), 5)
            ], 64))
          : _createCommentVNode("", true),
        (column.key === 'sex')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createTextVNode(_toDisplayString(text === 1 ? '男' : text === 2 ? '女' : '保密'), 1)
            ], 64))
          : _createCommentVNode("", true),
        (column.key === 'idle')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
              _createTextVNode(_toDisplayString(text ? '可接单' : '不可接单'), 1)
            ], 64))
          : _createCommentVNode("", true),
        (column.key === 'disable')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
              _createTextVNode(_toDisplayString(text ? '已禁用' : '启用'), 1)
            ], 64))
          : _createCommentVNode("", true),
        (column.key === 'action')
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_component_a_button, {
                size: "small",
                class: "action_btn",
                danger: record.disable === 0,
                type: "primary",
                onClick: ($event: any) => (_ctx.onSetStatus(record))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(record.disable ? '启用' : '禁用'), 1)
                ]),
                _: 2
              }, 1032, ["danger", "onClick"]),
              _createVNode(_component_a_button, {
                size: "small",
                class: "action_btn",
                onClick: ($event: any) => (_ctx.setVisible(record, true))
              }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 2
              }, 1032, ["onClick"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["dataSource", "columns", "loading", "pagination", "onChange"]),
    _createVNode(_component_a_modal, {
      visible: _ctx.visible,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.visible) = $event)),
      title: "修改用户信息",
      footer: null,
      onCancel: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setVisible(undefined, false)))
    }, {
      default: _withCtx(() => [
        (_ctx.editItem)
          ? (_openBlock(), _createBlock(_component_OwnerSet, {
              "edit-item": _ctx.editItem,
              key: _ctx.editItem?.id,
              reset: _ctx.onClose
            }, null, 8, ["edit-item", "reset"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}